var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEqualDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 210
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "equal_desktop_svg__a",
    x1: 0.825,
    y1: 0.5,
    x2: -0.02,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#158462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68c181"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7211"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4092",
    d: "M0 0h450v210H0z",
    fill: "url(#equal_desktop_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7252"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1916",
    fill: "#7cce87",
    d: "M0 0h75v210H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1917",
    fill: "#68c181",
    d: "M75 0h75v210H75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1918",
    fill: "#3faf77",
    d: "M149.999 0h75v210h-75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1919",
    fill: "#209e6e",
    d: "M225 0h75v210h-75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1920",
    fill: "#17936f",
    d: "M300 0h75v210h-75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1921",
    fill: "#158462",
    d: "M374.999 0h75v210h-75z"
  })))));
}

export default __webpack_public_path__ + "static/media/equal_desktop.ca04aeef41a5b5fdbac1a1453ae84510.svg";
export { SvgEqualDesktop as ReactComponent };